import { StyledReleaseTitle } from '../styled';

export type ReleaseTitleProps = {
  title: string;
};

export const ReleaseTitle = ({ title }: ReleaseTitleProps) => {
  return <StyledReleaseTitle>{title}</StyledReleaseTitle>;
};
